export enum FormStatusType {
  NO_CHANGES,
  SAVING,
  INVALID,
  SAVED,
  ERROR_WHILE_SAVING,
  ERROR_MISSING_FIELD,
  ERROR_VALIDATION,
  VALID_UNSAVED_CHANGES,
  VALIDATING,
}

export const formStatusTypeMap: FormStatusTypeMapping[] = [
  { type: FormStatusType.NO_CHANGES, color: 'medium', text: '...' },
  { type: FormStatusType.SAVING, color: 'warning', text: 'Ukládám...' },
  {
    type: FormStatusType.INVALID,
    color: 'danger',
    text: 'Formulář obsahuje chyby',
  },
  {
    type: FormStatusType.VALID_UNSAVED_CHANGES,
    color: 'danger',
    text: 'Formulář má neuložené změny',
  },
  { type: FormStatusType.SAVED, color: 'medium', text: 'Záznam uložen' },
  {
    type: FormStatusType.ERROR_WHILE_SAVING,
    color: 'danger',
    text: 'Chyba při ukládání',
  },
  {
    type: FormStatusType.ERROR_MISSING_FIELD,
    color: 'danger',
    text: 'Vyplňte všechna povinná pole',
  },
  {
    type: FormStatusType.ERROR_VALIDATION,
    color: 'danger',
    text: 'Formulář obsahuje chyby',
  },
  {
    type: FormStatusType.VALIDATING,
    color: 'warning',
    text: 'Probíhá kontrola',
  },
]

export interface FormStatusTypeMapping {
  type: FormStatusType
  text: string
  color: string
}
